export const STATUS_FREEZE = 'SUB_MEMBER_STATUS_FROZEN'; // 冻结
export const STATUS_BAN = 'SUB_MEMBER_STATUS_BAN'; // 登录权限禁用
export const CAN_NOT_QUICK_SWITCH = 0; // 禁止快速切换
export enum SubMemberType {
  /**普通子账号 */
  ORDINARY_ACCOUNT = 'MEMBER_RELATION_TYPE_OWN',
  /**托管子账号 */
  TRUST_ACCOUNT = 'MEMBER_RELATION_TYPE_ENTRUST_TRADE',
  /**资金托管子账号 该类型子账号已废弃*/
  FUND_TRUST_ACCOUNT = 'MEMBER_RELATION_TYPE_FUND_ENTRUST_TRADE',
  /**CopyTrading子账号 */
  COPY_TRADING_ACCOUNT = 'MEMBER_RELATION_TYPE_COPY_TRADE_LEADER',
  /**
   * Copypro 子账号
   * 每个母账号只能创建一个 copypro 子账号，且 copypro 子账号一定为 uta 账号
   * 子账号列表页：划转、设置按钮禁用，昵称带有 copypro 标识
   * API权限：资产 - 钱包 - 资产账户划转 & 母子账户划转 & 提币 权限不可选
   **/
  COPY_PRO_ACCOUNT = 'MEMBER_RELATION_TYPE_COPY_PRO',
  /**
   * 伊斯兰子账号
   * 该子账户类型为前端自定义，用于UI展示，后端并无该类型
   */
  ISLAMIC_ACCOUNT = 'MEMBER_RELATION_TYPE_ISLAMIC',
  EARN_FUND_ACCOUNT = 'MEMBER_RELATION_TYPE_EARN_FUND',
}

export enum UTA_STATUS {
  PROCESS = 'utaProcess',
  SUCCESS = 'uta',
  INVERSE = 'uta_inverse',
}

export const ERROR_CODE = {
  NEED_2FA: 31019,
  USER_BANNED: 31003,
  USERNAME_PASSWORD_ERROR_TIMES: 31002,
  USERNAME_PASSWORD_ERROR_LIMIT: 31030,
  HK_USER_LOGIN_BYBIT: 400601,
  BYBIT_USER_LOGIN_HK: 400602,
  TR_USER_LOGIN_BYBIT: 400605,
  BYBIT_USER_LOGIN_TR: 400606,
};

export const FORBIDDEN_LOGIN_CODES = [
  ERROR_CODE.BYBIT_USER_LOGIN_HK,
  ERROR_CODE.BYBIT_USER_LOGIN_TR,
  ERROR_CODE.HK_USER_LOGIN_BYBIT,
  ERROR_CODE.TR_USER_LOGIN_BYBIT,
];

export const SUB_ACCOUNT_LOGIN_CAPTCHA_SCENE = '31002';

export const LOGIN_NAME_REGEX = /^[0-9a-zA-Z]{6,16}$/;

export const LOGIN_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,30}$/;
